import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Button } from '@material-ui/core'
import ButtonWithLoader from '../ui/ButtonWithLoader/ButtonWithLoader'
import gameFormFooterStyles from './gameFormFooter.styles'

const useStyles = makeStyles(gameFormFooterStyles)

const GameFormFooter = ({
  requiredNote,
  cancelLabel,
  onCancel,
  submitLabel,
  submitLoading,
  submitDisabled,
  formId,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <span className={classes.note}>
        <span className={classes.asterisk}>*</span>
        {` ${requiredNote}`}
      </span>
      <div className={classes.actions}>
        {onCancel && (
          <Button className={classes.cancelButton} onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
        <ButtonWithLoader
          className={classes.submitButton}
          label={submitLabel}
          loading={submitLoading}
          disabled={submitDisabled}
          form={formId}
        />
      </div>
    </div>
  )
}

GameFormFooter.propTypes = {
  requiredNote: PropTypes.string,
  cancelLabel: PropTypes.string,
  onCancel: PropTypes.func,
  submitLabel: PropTypes.string,
  submitLoading: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  formId: PropTypes.string,
}

GameFormFooter.defaultProps = {
  requiredNote: 'Required fields',
  cancelLabel: 'Cancel',
}

export default GameFormFooter
